// Error messages
export const ERROR_MESSAGES = {
  UPLOAD_ERROR: '上传失败，请重试',
  UPLOAD_FAILED: '上传失败，请重试',
  TRANSCRIPTION_ERROR: '转录失败，请重试',
  CHECK_ERROR: '检查失败，请重试',
  TRANSCRIPTION_PROCESS_ERROR: '转录处理失败',
  NETWORK_ERROR: '网络错误，请检查连接',
  FILE_TOO_LARGE: '文件过大，请选择较小的文件',
  FILE_PARSE_ERROR: '文件解析失败，请检查文件格式',
  INVALID_FILE_TYPE: '不支持的文件类型',
  USER_ID_ERROR: '用户ID错误或未登录',
  GUEST_LIMIT_EXCEEDED: '游客没有使用次数了，请登录后再试～',
  DOCX_GENERATION_FAILED: '生成DOCX文件失败，请重试。',
  PAYMENT_CREATION_FAILED: '创建支付失败，请重试',
  COMMON_CREATION_FAILED: '失败，请重试',
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
  UPLOAD_SUCCESS: '上传成功！',
  TRANSCRIPTION_SUCCESS: '转录完成！',
  OPERATION_SUCCESS: '操作成功！',
  COPY_SUCCESS: '复制成功！',
  DOCX_DOWNLOAD_SUCCESS: 'DOCX文件已生成并下载！',
} as const;

// 状态消息常量
export const STATUS_MESSAGES = {
  UPLOADING: '正在上传',
  TRANSCRIBING: '处理中',
  TRANSCRIPTION_COMPLETE: '转录完成',
  TRANSCRIPTION_ERROR: '转录出错',

} as const;



// File related constants
export const FILE_CONSTANTS = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['.docx'],
  ACCEPT: '.docx',
  ACCEPTED_DOC_FORMATS: '.docx',
  MAX_COUNT: 1,
  MAX_UPLOAD_COUNT: 2,
  PART_SIZE: 5 * 1024 * 1024, // 5MB for audio chunks
};



// UI 相关常量
export const UI_CONSTANTS = {
  GUEST_INITIAL_COUNT: 5,
  MAX_UPLOAD_COUNT: 2,
} as const;

// 产品类型枚举
export enum ProductTypeEnum {
  VIP1 = 1,
  VIP2 = 2,
}